import { history } from "../";
import { API } from "aws-amplify";
import { apiGateway } from "../../config";
import { store } from "../";
import {
  ADD_CUSTOM_NAVIGATION_ITEMS,
  FETCHED_CUSTOM_NAVIGATION_ITEMS,
  FETCHING_CUSTOM_NAVIGATION_ITEMS,
  ADD_CUSTOM_NAVIGATION_ITEM,
  UPDATE_CUSTOM_NAVIGATION_ITEM,
  DELETE_CUSTOM_NAVIGATION_ITEM
} from "./constants";

const Gateway = apiGateway.find((gateway) => gateway.name === "client");

export const externalNavigate = (location, state = {}, new_tab) => {
  if (!new_tab) history.push(location, state);
  else window.open(location, "_blank", "noopener noreferrer");
};

export const getCustomNavigationItems = (project_id, override = false) => async (dispatch) => {
  if ((!store.getState().navigation.fetching && !store.getState().navigation.fetched[project_id]) || override) {
    dispatch({ type: FETCHING_CUSTOM_NAVIGATION_ITEMS, payload: true });
    return API.get(
      Gateway.name,
      `/navigation/get-all/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`,
      {
        headers: {
          "Authorization": store.getState().session.token
        }
      })
      .then(async (data) => {
        dispatch({ type: ADD_CUSTOM_NAVIGATION_ITEMS, payload: { list: data.payload, project_id } });
        dispatch({ type: FETCHED_CUSTOM_NAVIGATION_ITEMS, payload: { status: true, project_id } });
        dispatch({ type: FETCHING_CUSTOM_NAVIGATION_ITEMS, payload: false });
      })
      .catch((error) => {
        if (error?.response?.data?.payload && !error.response.data.payload.length) dispatch({ type: ADD_CUSTOM_NAVIGATION_ITEMS, payload: { list: [], project_id } });
        dispatch({ type: FETCHED_CUSTOM_NAVIGATION_ITEMS, payload: { status: true, project_id } });
        dispatch({ type: FETCHING_CUSTOM_NAVIGATION_ITEMS, payload: false });
        return {
          success: false,
          error
        };
      });
  }
};

export const createCustomNavigationItem = (project_id, data) => async (dispatch) => {
  return API.post(Gateway.name, `/navigation/create/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: {
      Authorization: store.getState().session.token,
    },
    body: {
      navigation_item: data,
      project_id
    },
  })
    .then((data) => {
      dispatch({ type: ADD_CUSTOM_NAVIGATION_ITEM, payload: data.payload });
      return data;
    })
    .catch((error) => {
      return {
        success: false,
        message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
      };
    });
};

export const updateCustomNavigationItem = (navigation_item_id, updates) => async (dispatch) => {
  return API.patch(Gateway.name, `/navigation/update/${navigation_item_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: {
      Authorization: store.getState().session.token,
    },
    body: {
      updates
    },
  })
    .then((updated) => {
      dispatch({ type: UPDATE_CUSTOM_NAVIGATION_ITEM, payload: updated.payload });
      return updated;
    })
    .catch((error) => {
      return {
        success: false,
        message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
      };
    });
};

export const deleteCustomNavigationItem = (navigation_item_id, project_id) => async (dispatch) => {
  return API.del(Gateway.name, `/navigation/delete/${navigation_item_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: {
      Authorization: store.getState().session.token,
    }
  })
    .then((deleted) => {
      dispatch({ type: DELETE_CUSTOM_NAVIGATION_ITEM, payload: { project_id, id: navigation_item_id } });
      return deleted;
    })
    .catch((error) => {
      return {
        success: false,
        message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
      };
    });
};